import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const addLandlordRefereeMutation = gql`
  mutation addLandlordReferee(
    $customerId: String!
    $subjectId: String!
    $userId: String!
    $email: String!
    $name: String!
    $phone: String!
  ) {
    addLandlordReferee(
      customerId: $customerId
      subjectId: $subjectId
      userId: $userId
      email: $email
      name: $name
      phone: $phone
    )
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  email: string
  name: string
  phone: string
}

export type AddLandlordRefereeData = {
  addLandlordReferee: string | unknown
}

export const useAddLandlordRefereeMutation: WrappedMutation<
  AddLandlordRefereeData,
  MutationVars
> = () =>
  useMutation<AddLandlordRefereeData, MutationVars>(addLandlordRefereeMutation, {
    client: agentClient,
  })
